<template>
  <div class="loading-placeholder"
       :class="{ 'loading-placeholder--sneaky': sneaky }"
  >
    <slot v-if="!loading"/>
    <transition :name="animation">
      <div v-if="loading && !sneaky"
           class="loading-placeholder__placeholder"
      >
        <LoadingRow v-for="row in rows"
                    :key="row"
                    class="loading-placeholder__row"
                    :container-height="height"
                    :container-width="width"
                    :rounded="rounded"
                    :dynamic-styles="styles"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingRow from '@/components/partials/Loading/LoadingRow.vue'

export default {
  name: 'LoadingPlaceholder',

  components: { LoadingRow },

  props: {
    animation: {
      type: String,
      default: '',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    sneaky: {
      type: Boolean,
      default: false,
    },

    rounded: {
      type: Boolean,
      default: true,
    },

    width: {
      type: String,
      default: '100%',
    },

    height: {
      type: String,
      default: '1rem',
    },

    styles: {
      type: Object,
      default: () => ({}),
    },

    rows: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-placeholder {
  $self: &;
  position: relative;
  width: 100%;

  &__row {
    &:last-child {
      margin-bottom: 0;
    }
  }

  &__placeholder {
    width: 100%;
    height: 100%;
  }
}
</style>
